import { FunctionComponent } from 'react'

import styled, { css, useTheme } from 'styled-components'

import translate from '@i18n'
import SvgIcon from '@components/SvgIcon'

const StyledHeader = styled.div`
  ${({
    theme: {
      spacing: { spacing8 },
    },
  }) => css`
    display: flex;
    gap: ${spacing8};
    flex-direction: column;
  `}
`

const StyledHeaderHeading = styled.h3`
  ${({
    theme: {
      typography: {
        headings: { small },
      },
    },
  }) => css`
    ${small}
  `}
`

const StyledHeaderDisclaimer = styled.div`
  ${({
    theme: {
      typography: {
        subheads: { xsmall2 },
      },
      colors: { textWeak },
      spacing: { spacing8 },
    },
  }) => css`
    ${xsmall2};
    color: ${textWeak};
    display: flex;
    align-items: center;
    gap: ${spacing8};
  `}
`

const NewArticleSummaryHeader: FunctionComponent<{
  className?: string
}> = ({ className }) => {
  const {
    colors: { iconWeak },
  } = useTheme()
  return (
    <StyledHeader className={className}>
      <StyledHeaderHeading>
        {translate('newArticleSummary.title')}
      </StyledHeaderHeading>
      <StyledHeaderDisclaimer>
        <SvgIcon iconName="stars" size={16} color={iconWeak}></SvgIcon>
        <span>{translate('newArticleSummary.subTitle')}</span>
      </StyledHeaderDisclaimer>
    </StyledHeader>
  )
}

export default NewArticleSummaryHeader
